import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { ROUTES } from "../../constants/constants";

const DashboardRedirect = () => {
  const { isSearchTypeAllowed } = useAuth();

  if (isSearchTypeAllowed("TM_Manager")) {
    return <Navigate to={ROUTES.PORTFOLIO} replace />;
  }

  return <Navigate to={ROUTES.SEARCH} replace />;
};

export default DashboardRedirect;
